var _path, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _circle5, _circle6, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeliveryCarSale = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 60,
    viewBox: "0 0 76 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 56H57M10 56H7C3.68629 56 1 53.3137 1 50V4C1 2.34315 2.34315 1 4 1H47.0611C48.718 1 50.0611 2.34315 50.0611 4V29.0096C50.0611 30.6665 51.4043 32.0096 53.0611 32.0096H66M50.0611 8.125C68.3 8.125 75 18.25 75 32.0096C75 39.3506 75 45.6871 75 50.0014C75 53.3151 72.3137 56 69 56V56M66 32.0096V24C66 23.4477 66.4501 22.9873 66.9989 23.0494C69.316 23.3114 70.8442 24.7719 70.9888 31.005C71.0016 31.5572 70.5523 32.0096 70 32.0096H66Z",
    stroke: "#B3B2C2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 52,
    r: 7,
    stroke: "#B3B2C2",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 52,
    r: 3,
    stroke: "#B3B2C2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 52,
    r: 7,
    stroke: "#B3B2C2",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 52,
    r: 3,
    stroke: "#B3B2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 40H75",
    stroke: "#B3B2C2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 50H9M75 50H70M22.5 50H56.5",
    stroke: "#B3B2C2",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71 41V42C71 43.6569 72.3431 45 74 45H75",
    stroke: "#B3B2C2",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14,
    r: 3.25,
    stroke: "#B3B2C2",
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    r: 3.25,
    stroke: "#B3B2C2",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11L17.001 28.999",
    stroke: "#B3B2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeliveryCarSale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deliveryCarSale.f6acb2d2097f82bd769eee5bfecceb61.svg";